import React, { useState } from "react";
import { Auth } from "aws-amplify";
import logo from "../assets/images/logo.png";
import "../assets/css/style.css";
import "../assets/vendors/base/vendor.bundle.base.css";
import "../assets/vendors/ti-icons/css/themify-icons.css";
import { invokeLambdaWithRetry } from "../../services/Helper";

const ATL_USERNAME = "ui.automation@meaplatform.com";
const ATL_GROUP = "MEA_AUTOMATION_RESTRICTED";

const isAtlAuthorized = (response) => Boolean(
  response?.authorized ||
  response?.response?.authorized ||
  response?.response?.response?.authorized
);

const validateAtlAccess = async (user, expectedUsername) => {
  const response = await invokeLambdaWithRetry("instanceHandler", {
    body: {
      target: "validate-atl-access",
      access_token: user?.signInUserSession?.idToken?.jwtToken,
      expectedUsername,
      requiredGroup: ATL_GROUP,
    },
  }, undefined, undefined, true);
  if (!isAtlAuthorized(response)) {
    throw new Error("Access denied.");
  }
};

function Atl() {
  const [username, setUsername] = useState(ATL_USERNAME);
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    const normalizedUsername = username.trim().toLowerCase();
    if (normalizedUsername !== ATL_USERNAME) {
      setError("Access denied.");
      return;
    }

    setBusy(true);
    try {
      const user = await Auth.signIn(normalizedUsername, password);
      await validateAtlAccess(user, normalizedUsername);
      window.location.href = "/user/submissions";
    } catch (err) {
      await Auth.signOut().catch(() => {});
      setError(err?.message || "Login failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper auth-pages d-flex align-items-stretch auth auth-img-bg">
          <div className="row flex-grow">
            <div className="col-lg-6 login-half-bg d-flex flex-row">
              <p className="text-white font-weight-medium text-center flex-grow align-self-end">&copy; mea platform limited {new Date().getFullYear()}.</p>
            </div>
            <div className="col-lg-6 d-flex align-items-center justify-content-center">
              <div className="auth-form-transparent text-left p-3">
                <div className="brand-logo">
                  <img src={logo} alt="logo" /> <span className="text-white logo-txt">platform</span>
                </div>
                <form className="pt-3" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      id="atlUsername"
                      className="form-control form-control-lg"
                      autoComplete="username"
                      value={username}
                      onChange={(event) => setUsername(event.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      id="atlPassword"
                      className="form-control form-control-lg"
                      type="password"
                      autoComplete="current-password"
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                    />
                  </div>
                  {error && <div id="atlError" className="text-danger mb-3">{error}</div>}
                  <div className="my-3">
                    <button id="atlSubmit" type="submit" className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" disabled={busy}>
                      {busy ? "Signing in..." : "Continue"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Atl;
